import { Component } from '@opten/compiler/metadata/component';
import stickybits from 'stickybits';
import debounce from '@opten/reactive/debounce';

@Component({ className: 'js-sticky-basket' })
export class StickyBasketComponent {
	sticky: any;

	constructor(private _element: HTMLElement) {
		this.sticky = stickybits(this._element, {
			parentClass: 'js-sticky-basket-parent',
			stickyChangeClass: 'is--sticky-change',
			stickyClass: 'is--sticky',
			stuckClass: 'is--stuck',
			useStickyClasses: true,
			stickyBitStickyOffset: 60
		});

		this._element.addEventListener('update', () => {
			this.update();
		});

		window.addEventListener(
			'resize',
			debounce(() => this.update(), 250)
		);
	}

	private update() {
		if (this.sticky) {
			this.sticky.update();
		}
	}
}
